module.exports = __webpack_public_path__ + "static/img/pic_04@2x.7d37454f.png";